import { MultiPropertyProvider } from "../prop/MultiPropertyProvider";
/** @internal */
export class SelectionPropertyProvider extends MultiPropertyProvider {
    //// protected /////////////////////////////////////////////////////////////////////////////
    beginSetPropertyValue() {
        if (this.mApp != null)
            this.mApp.model.beginModification();
        super.beginSetPropertyValue();
    }
    endSetPropertyValue() {
        super.endSetPropertyValue();
        if (this.mApp != null)
            this.mApp.model.endModification();
    }
}
